export function checkPermission(permission: string, authorities: string[]): boolean {
  return authorities.some((item) => item === permission);
}
